export default __webpack_public_path__ + "static/media/terms_on.39bd9bb2.svg";